module.exports = __webpack_public_path__ + "img/watage_res_3.7434f7b6.gif";